export default __webpack_public_path__ + "static/media/svg-3.d3dabf2f.svg";